"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Prompt_1 = __importDefault(require("@/components/Prompt"));
const style_1 = require("@/components/Prompt/style");
function ComponentsPromptView({ saveChangesButtonLabel, discardChangesButtonLabel, onSaveChanges, onDiscardChanges, shouldShowPrompt, hasError, }) {
    return (react_1.default.createElement(Prompt_1.default, { saveChangesButtonLabel: saveChangesButtonLabel, discardChangesButtonLabel: discardChangesButtonLabel, onSaveChanges: onSaveChanges, onDiscardChanges: onDiscardChanges, shouldShowPrompt: shouldShowPrompt }, hasError ? (react_1.default.createElement(style_1.ErrorMessageWrapper, null,
        " ",
        react_1.default.createElement(Typography_1.default, { variant: "h5", style: { fontWeight: "bold" } }, "There are one or more empty values"))) : null));
}
exports.default = ComponentsPromptView;
